import React, { Suspense } from 'react'

import { useTranslation } from 'react-i18next'
import { Await, useLoaderData, useNavigation } from 'react-router-dom'

import LoadingMessage from '@components/LoadingMessage'
import ExternalLink from '@components/shared/ExternalLink'
import LoadingSpinner from '@components/shared/LoadingSpinner'
import { MyBooksLoaderResponse, PrivateBooksResponse } from '@pages/home/loaders/myBooks.loader'
import { usePageTitle } from '@providers/LayoutProvider'

const MyBooksPage: React.FC = () => {
  const { t } = useTranslation()
  const data = useLoaderData() as MyBooksLoaderResponse
  const navigation = useNavigation()

  usePageTitle(t('titles.myBooks'))

  const isReloading =
    navigation.state === 'loading' &&
    navigation.formData != null &&
    navigation.location.pathname === '/home/myBooks'

  return (
    <>
      {isReloading && <LoadingMessage />}
      <Suspense
        fallback={
          <>
            {/* Spacer */}
            <div className="h-16 w-full" />

            <LoadingSpinner />
          </>
        }>
        <Await resolve={data.privateBooks}>
          {({ books }: PrivateBooksResponse) =>
            books.map((book) => (
              <ExternalLink
                key={book.id}
                className="overflow-hidden relative mt-2 mb-5"
                href={`/content_packages/view/${book.id}`}>
                <div className="relative bg-white overflow-hidden w-full">
                  <img
                    className="w-full h-auto absolute"
                    src={`/content_packages/${book.id}/files/${book.listing_metadata?.image}`}
                    alt={book.listing_metadata?.title}
                  />
                </div>
                <p className="mt-2 ellipsify">{book.listing_metadata?.title}</p>
                <p className="mt-1 text-sm text-gray-text pb-2 ellipsify">
                  {book.listing_metadata?.publisher}
                </p>
              </ExternalLink>
            ))
          }
        </Await>
      </Suspense>
    </>
  )
}

export default MyBooksPage
